import { Component } from '@angular/core';

@Component({
    selector: 'app-non-authorized',
    imports: [],
    templateUrl: './non-authorized.component.html',
    styleUrl: './non-authorized.component.css'
})
export class NonAuthorizedComponent {

}
